export default __webpack_public_path__ + "static/media/pdf-icon.75f7c1d8.svg";